import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilesResponse } from '../../../services/file.service';

export type BreadcrumbScope = 'subject' | 'section' | 'topic';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <nav class="crumb" aria-label="breadcrumb">
      <button *ngIf="bundle.subject" type="button" class="crumb__seg" (click)="emit('subject')">
        {{ bundle.subject }}
      </button>
      <span *ngIf="bundle.subject && bundle.section" class="crumb__sep" aria-hidden="true">›</span>
      <button *ngIf="bundle.section" type="button" class="crumb__seg" (click)="emit('section')">
        {{ bundle.section }}
      </button>
      <span *ngIf="bundle.section && bundle.topic" class="crumb__sep" aria-hidden="true">›</span>
      <button *ngIf="bundle.topic" type="button" class="crumb__seg crumb__seg--leaf" (click)="emit('topic')">
        {{ bundle.topic }}
      </button>
    </nav>
  `,
  styles: [`
    .crumb {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: var(--space-1);
      font-size: var(--fs-xs);
      line-height: var(--lh-xs);
      color: var(--color-text-secondary);
    }
    .crumb__seg {
      background: none;
      border: 0;
      padding: 0;
      cursor: pointer;
      color: inherit;
      font: inherit;
      letter-spacing: 0.02em;
      text-transform: uppercase;
      font-weight: var(--fw-medium);
    }
    .crumb__seg:hover { color: var(--color-primary-600); }
    .crumb__seg--leaf { color: var(--color-text-primary); }
    .crumb__sep { color: var(--color-text-muted); }
  `]
})
export class BreadcrumbComponent {
  @Input({ required: true }) bundle!: FilesResponse;
  @Output() navigate = new EventEmitter<{ scope: BreadcrumbScope; bundle: FilesResponse }>();

  emit(scope: BreadcrumbScope): void {
    this.navigate.emit({ scope, bundle: this.bundle });
  }
}
